import script from "./GroupTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupTemplate.vue?vue&type=script&setup=true&lang=js"

import "./GroupTemplate.vue?vue&type=style&index=0&id=32c90796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c90796"]])

export default __exports__